import React from 'react';

import {
  makeStyles,
  Theme,
  createStyles,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { useEadTreeContext } from './EadTreeCtx';

import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    originatorWrapper: {
      display: 'flex',
      flexDirection: 'column',
      color: 'white',
      fontWeight: 'bold',
      fontSize: 16,
      padding: '16px',
    },
    originatorLabel: {
      padding: '0 8px',
      fontSize: 14,
      lineHeight: '24px',
    },
    originatorLabelSubclass: {
      padding: '4px 8px 0 12px',
      fontSize: 13,
      lineHeight: '24px',
      fontWeight: 'normal',
    },
    icon: {
      fontSize: 14,
      margin: `0 ${theme.spacing(1)}px`,
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.1)',
      },
    },
    tooltip: {
      fontSize: 12,
    },
  })
);
/**
 *
 * @param removeParams legacy fn to remove params when searching through archivals
 * @returns
 */
const OriginatorFilterActive: React.FC<{ removeParams?: () => void }> = ({
  removeParams,
}) => {
  const classes = useStyles();
  const { setOriginatorFilter, originatorFilter } = useEadTreeContext();
  if (!originatorFilter) {
    return <></>;
  }
  return (
    <div className={classes.originatorWrapper}>
      <div>
        <span>Rejstříkové heslo:</span>
        <Tooltip
          title={<span className={classes.tooltip}>Zrušit filtr</span>}
          placement="top"
        >
          <IconButton
            key="close"
            aria-label="Close"
            color="primary"
            onClick={() => {
              removeParams?.();
              setOriginatorFilter?.(undefined);
            }}
            className={classes.icon}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </div>
      <span className={classes.originatorLabel}>
        {originatorFilter.originator?.preferredName?.label}
      </span>
      <span className={classes.originatorLabelSubclass}>
        <i>- {originatorFilter.originator?.subClassLabel}</i>
      </span>
    </div>
  );
};

export default OriginatorFilterActive;
